import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class LanguagesService {

    public activeLanguage: string = 'en';
    private languageSource = new BehaviorSubject<string>('en');
    public  currentLanguage = this.languageSource.asObservable();

    private langIdSource = new BehaviorSubject<string>('0');
    private currentLangId = this.langIdSource.asObservable();

    public isRightToLeft = false;

    private loggedSource: Subject<boolean> = new BehaviorSubject<boolean>(false);
    private loggedFlag = this.loggedSource.asObservable();

    setLanguage(lang: string) {
        this.activeLanguage = lang;
        this.languageSource.next(lang);
    }

    getLanguage() {
        return this.currentLanguage;
    }

    setLangId(id: string) {
        this.langIdSource.next(id);
    }

    getLangId() {
        return this.currentLangId;
    }

    setFlag(flag: boolean) {
        this.isRightToLeft = flag;
    }

    setLogged(flag: boolean) {
        this.loggedSource.next(flag);
    }

    getLogged() {
        return this.loggedFlag;
    }
}